var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGitHubStyleWhite = function SvgBrandGitHubStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandGitHubStyleWhite__clip0_118_367302)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 .3C5.362.3 0 5.662 0 12.3c0 5.287 3.45 9.789 8.211 11.4.6.113.827-.262.827-.562v-2.025C5.7 21.825 4.987 19.5 4.987 19.5c-.562-1.389-1.35-1.762-1.35-1.762-1.086-.751.076-.713.076-.713 1.2.075 1.836 1.237 1.836 1.237 1.089 1.838 2.813 1.314 3.489 1.012.113-.787.411-1.312.749-1.612-2.662-.3-5.474-1.349-5.474-5.924 0-1.313.45-2.363 1.236-3.225-.111-.3-.524-1.538.113-3.188 0 0 1.012-.338 3.3 1.237a11.6 11.6 0 0 1 3-.411c1.012 0 2.063.149 3 .411 2.289-1.537 3.3-1.237 3.3-1.237.638 1.65.225 2.888.113 3.188.789.823 1.238 1.912 1.238 3.223 0 4.613-2.813 5.626-5.475 5.926.411.376.824 1.087.824 2.212v3.302c0 .337.225.71.825.562C20.55 22.087 24 17.587 24 12.3c0-6.638-5.362-12-12-12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandGitHubStyleWhite__clip0_118_367302"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGitHubStyleWhite);
export { ForwardRef as ReactComponent };